import "./PreviousNode.css";

import { useIntl } from "react-intl";

import { type CustomNodeTypes, type NodeData } from "../../types";
import { NodeItem } from "../NodeItem";

export default function PreviousNode({
  data,
  onNodeClick,
}: {
  data: NodeData;
  onNodeClick: () => void;
}) {
  const intl = useIntl();
  const onClick = () => onNodeClick();

  return (
    <div className="Nhi-AccessMap-previous-node">
      <div>
        {intl.formatMessage({
          id: "N0lLKq",
          defaultMessage: "Previous Views",
          description:
            "Header text for the section showing previously viewed nodes in the access map",
        })}
      </div>
      <div role="button" tabIndex={0} onClick={onClick} onKeyDown={onClick}>
        <NodeItem
          data={data}
          isLeftNode={false}
          type={`${data.label}s` as CustomNodeTypes}
          hideMenu
        />
      </div>
    </div>
  );
}
